import useRequestUtils from "./useRequestUtils"
import useModelBuilder from "./useModelBuilder"

/**
 * The purpose of this javascript function is to manage all facets of an application context.  It takes advantage of the
 * nuxt/vue composition API so that it can create and manage a reactive instance of the context encapsulated within itself.
 */
export default function useAppContext(defaultContext, req) {

  const { cleanContext }  = useModelBuilder() 

  let context

  //Use the ref Vue composition API function to create a reactive reference for the context.
  if (!context) context = defaultContext ? defaultContext : {}

  try {
    contextFromRequest(req)
  } catch (e) {
    console.log(e)
  }

  /**
   * This encapsulated function builds up the application context from information on the response.  If there are query parameters on the
   * URL, we will build up the context from the query parameters and store the context as a cookie on the browser. If there are no query
   * parameters supplied, then we will attempt to create the context from a cookie stored on the browser.
   *
   * There are two attributes configured per application in the appConfig.js file
   *
   * contextCookieName - The name of the application's cookie to be stored on the browser
   * contextCookieMaxAge - The maximum age cookie before it expires.
   */
  function contextFromRequest(req) {

    const cleanCtx = cleanContext()

    //const query = req.query ? req.query : {}
    const { queryFromReq } = useRequestUtils()
    let query = queryFromReq(req)

    let paramCount = 0
    for (let param in query) {
      paramCount++
    }

    //If params were supplied via the query, then add them to the context.
    if (paramCount > 0) {
      for (let param in query) {
        if (query[param] != '' && query[param] != null && query[param] != undefined && query[param] != 'null' && query[param] != 'undefined') {

          //The following params need to resolve to arrays, but they may only come in as a single item. If
          //they come in as a multi-param, they will get resolved to an Array.  If not, we need to create the 
          //array of 1.
          if (param == 'cc' || param == 'races' || param == 'ethnicities' || param == 'origins' && cleanCtx.hasOwnProperty(param)) {
            context[param] = Array.isArray(query[param]) ? query[param] : [query[param]]
          } else {
            context[param] = query[param]
          }
        }
      }
    }
  }

  //If betterChoiceContext makes its way into the URL via something like location or practitioner detail, remove it from the 
  //context as it is not relevant and unnecessarily polutes the context and the URL.  The betterChoiceContext is managed in the model
  //in the csearch app.
  if ( context.betterChoiceContext ) {
    delete context.betterChoiceContext;
  }

  return context
}